import {
  ActionReducerMapBuilder,
  createAction,
  createReducer,
  PayloadAction,
} from "@reduxjs/toolkit";
import { DefaultDashboardSlotsState, DashboardSlotsState } from "../state/stateItems";
import { TDashboardSlotItem } from "@/data/types";
import { getAllDashboardSlotsAsync, getDashboardSlotByIdAsync } from "../actions";

const handleGetAllDashboardSlotsAsync = (
  state: DashboardSlotsState,
  action: PayloadAction<{ items: TDashboardSlotItem[] }>
) => {
  if (!action?.payload) {
    return state;
  }

  const { items } = action.payload;

  state.items = items;
};

const handleGetDashboardSlotByIdAsync = (
  state: DashboardSlotsState,
  action: PayloadAction<TDashboardSlotItem>
) => {
  if (!action?.payload) {
    return state;
  }

  const dashboardSlot = action.payload;

  state.currentDashboardSlot = dashboardSlot;
};

const reducerBuilder = (builder: ActionReducerMapBuilder<DashboardSlotsState>) => {
  builder.addCase(getAllDashboardSlotsAsync.fulfilled.type, handleGetAllDashboardSlotsAsync);
  builder.addCase(getDashboardSlotByIdAsync.fulfilled.type, handleGetDashboardSlotByIdAsync);
};

export default createReducer(DefaultDashboardSlotsState, reducerBuilder);